import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_org_label_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_label_hdr: fromDatatype.GuidDataFieldInterface;
  guid_company: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_fi_org_label_link_RowClass
  implements bl_fi_org_label_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_label_hdr: fromDatatype.GuidDataFieldInterface;
  guid_company: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
